import css from "./style.scss";
import cx from "classnames";
import { Text } from "preact-i18n";
import QrForm from "../qr-form";
import FieldWithButton from "../field-with-button";
import BackTo from "../back-to";
import { useState } from "preact/hooks";
import copy from "copy-to-clipboard";
import Timer from "../timer";
import useInvoice from "../../hooks/useInvoice";

const SendPayment = () => {
  const { invoice, selectCurrency, clearCurrency } = useInvoice();

  const [copied, setCopied] = useState(false);

  const copyToClip = (str) => {
    copy(str);
  };

  const fields = [
    {
      name: "Network",
      value: invoice.network?.network,
      icon: "change",
    },
    {
      name: `${invoice.currency?.name} address`,
      value: invoice.network?.address,
      icon: copied ? "done" : "copy",
    },
  ];

  const setCopiedIcon = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  return (
    <div class={cx(css.wrapper)} tabindex="2">
      <div class={cx(css.head)}>
        <div class={cx(css.text)}>
          <div class={cx(css.header)}>
            <Text id="payment.send-payment">Send payment</Text>
          </div>
          <div class={cx(css.subheader)}>
            <Text id="payment.to-make-a">
              To make a payment, send funds by using the QR code or address
              below.
            </Text>
          </div>
        </div>
        <Timer />
      </div>
      <div class={cx(css.gray)}>
        {fields[1]?.value ? <QrForm address={fields[1]?.value} /> : null}
        <div class={cx(css.fields)}>
          {invoice.currency?.types?.length > 1 && (
            <FieldWithButton onClick={() => selectCurrency(invoice.currency, null)} {...fields[0]} />
          )}
          <div class={cx(css.relative)}>
            <FieldWithButton
              onClick={() => (copyToClip(fields[1]?.value), setCopiedIcon())}
              {...fields[1]}
            />
            <div class={cx(css.tooltip, copied && css.show)}>
              <Text id="tooltip.copied">Copied!</Text>
            </div>
          </div>
        </div>
      </div>
      <div class={cx(css.back)}>
        <BackTo onClick={() => clearCurrency()}>
          <Text id="back.change-payment">Back to select payment method</Text>
        </BackTo>
      </div>
    </div>
  );
};
export default SendPayment;
